import { useQuery } from '@tanstack/react-query';

import { api } from '../api/client';

interface UseBatchesParams {
  /** Default ``false`` — only active batches (have ``pending`` or
   *  ``submitted`` jobs). Set ``true`` to also receive terminal-only
   *  batches within the lookback window. */
  include_completed?: boolean;
  /** Max number of batches to return. Default backend cap is 20;
   *  the FeedScreen renders only the first 3. */
  limit?: number;
}

/** Phase 3.14 — poll ``GET /api/v1/batches`` for the Feed "Активные
 *  партии" section.
 *
 *  30-second ``refetchInterval`` because the primary use-case is
 *  "operator wakes up, opens Mini App, sees what's running" — they
 *  want progress to tick forward visibly while the screen is open.
 *  Cheaper than the 5 s jobs/status pulse since the underlying query
 *  is a ``GROUP BY tag`` over a few hundred rows.
 */
export function useBatches({
  include_completed = false,
  limit = 20,
}: UseBatchesParams = {}) {
  return useQuery({
    queryKey: ['batches', { include_completed, limit }],
    queryFn: () => api.listBatches({ include_completed, limit }),
    refetchInterval: 30_000,
    staleTime: 10_000,
  });
}
